import { Box, Typography, useTheme } from "@mui/material";
import { BenefitItemProps } from "./types";
import useResponsive from "@/hooks/useResponsive";
import { useState } from "react";
import { FONT_PRIMARY } from "@/theme/typography";

const calc = (o: number, diff: number) => `translateY(${o * diff}px)`;

const BenefitItem = ({ sx, offset, speed, label, description, icon: Icon }: BenefitItemProps) => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "md");
  const [open, setOpen] = useState<boolean>(false);

  const onClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        ...sx,
        transform: calc(offset, speed),
        position: "absolute",
        padding: "12px 24px",
        borderRadius: "12px",
        boxShadow: "0px 24px 48px -12px #5D61681A",
        boxSizing: "border-box",
        maxWidth: "500px",
        backgroundColor: theme.palette.common.white,
        cursor: { md: "pointer" },
        display: "flex"
      }}
      {...(!isMobile ? { onClick } : null)}
    >
      <Box
        sx={{
          marginRight: { xs: "15px", md: "18px" }
        }}
      >
        <Icon />
      </Box>
      <Box>
        <Typography
          sx={{
            ...(open ? { marginBottom: "8px" } : null),
            fontSize: "1.125rem",
            fontWeight: "700",
            fontFamily: FONT_PRIMARY
          }}
        >
          {label}
        </Typography>
        {open ? (
          <Typography
            variant="subtitle1"
            component="p"
            color={theme.palette.grey[600]}
          >
            {description}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default BenefitItem;